const REOPS_EMAIL_SUFFIX = '@re-ops.co';

export const isReOpsEmail = (email?: string | null): boolean => {
    if (!email) {
        return false;
    }

    return email.trim().toLowerCase().endsWith(REOPS_EMAIL_SUFFIX);
};
